<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-23 15:24:05
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-18 16:54:57
 * @name: 大图
 * @Description: 大图
 * @FilePath: \project\src\components\public\big-image.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div class="bigImage-floating" v-if="show" @click="show = false">
    <img :src="url" @click.stop/>
  </div>
</template>
<script>
export default {
  name: "bigImage",
  data() {
    return {
      url: "", //图片地址
      show: false, //是否展示
    };
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 展示图片
     * @param {String} url 图片地址
     */    
    open(url) {
      this.url = url;
      this.show = true;
    },
  },
};
</script>
<style lang="scss" scoped>
  .bigImage-floating {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    box-sizing: border-box;
    padding: 20px 0;
    background: $Var-floating-color;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    overflow-y: auto;
    z-index: 1000;
    img {
      margin: auto 0;
      max-width: 500px;
      min-width: 200px;
    }
  }
</style>